package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.AvailabilityRepository

class RemoveDateOverrideUseCase(
    private val repository: AvailabilityRepository
) {
    suspend operator fun invoke(overrideId: String): Result<Unit> {
        if (overrideId.isBlank()) {
            return Result.failure(IllegalArgumentException("ID da exceção é obrigatório."))
        }
        return repository.removeDateOverride(overrideId)
    }
}
